import { module } from 'modujs';


export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        this.carousel = this.$('carousel')[0]

        if (!this.carousel) this.carousel = this.el

        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
        this.pagination = this.$('pagination')[0]

        this.$visuals = this.$('visual')

        // Data
        this.isProjectCarousel = this.getData('project') != null ? true : false
    }

    init() {
        this.length = this.$('item').length

        const args = {
            speed: 1000,
            loop: this.isProjectCarousel ? false : true,
            spaceBetween: 0,
            // loopedSlides: 3,
            parallax: true,
            grabCursor: true,
            slidesPerView: 1,
            threshold: 2,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
            pagination: {
                el: this.pagination,
                type: "fraction",
            },
            on: {
                init: () => {
                    this.computeVisualHeight()
                },
                slideChangeTransitionEnd: () => {
                    this.carousel?.lazy?.load()
                }
            },
        }

        if (this.length > 1) {
            this.el.classList.add('has-item')
            this.carousel = new Swiper(this.carousel, args)
        }

        if (this.length < 2) {
            this.arrowPrev.classList.add('is-invisible')
            this.arrowNext.classList.add('is-invisible')
        }

        this.bindEvents()
    }

    destroy() {
        if (this.carousel && this.carousel.destroy) this.carousel.destroy(true, true)

        this.unbindEvents()
    }

    bindEvents() {
        window.addEventListener("resize", this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener("resize", this.onResizeBind)
    }

    inview(e) {
        if(e.obj.el == this.el) {
            if(this.carousel && this.carousel.params) this.carousel.params.lazy.loadPrevNext = true;
            this.carousel?.lazy?.load?.()

            if(this.length < 2) {
                for(let item of Array.from(this.$('item'))) {
                    let lazyArray = item.querySelectorAll('.swiper-lazy')
                    for(let el of lazyArray) {
                        this.call('lazyLoad', { obj: { el } }, 'Scroll')
                    }
                }
            }
        }
    }

    onResize() {
        this.computeVisualHeight()
    }

    computeVisualHeight() {
        this.el.style.setProperty("--max-visual-height", '100%');
        this.el.style.flex = 1;

        requestAnimationFrame(() => {
            const heights = []

            let visualIndex = 0
            while (visualIndex < this.$visuals.length) {
                heights.push(this.$visuals[visualIndex].offsetHeight)
                visualIndex++
            }

            const minHeight = Math.min(...heights);

            this.el.style.setProperty("--max-visual-height", `${minHeight}px`);
            this.el.style.flex = "inherit";
        })
    }
}
